var addMapEntry = require('./_addMapEntry'),
    arrayReduce = require('./_arrayReduce'),
    mapToArray = require('./_mapToArray');

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map) {
  return arrayReduce(mapToArray(map), addMapEntry, new map.constructor);
}

module.exports = cloneMap;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_cloneMap.js
 ** module id = 1225
 ** module chunks = 0
 **/